export default __webpack_public_path__ + "static/media/image-gray.2403fa52.svg";